'use client';
import { motion } from 'motion/react';
import Link from 'next/link';
import { useAuth } from '~/auth/hooks';
import { getInitials } from '~/utils';

export const AvatarLink = ({
  href,
  className,
}: {
  href: string;
  className?: string;
}) => {
  const { userProfile } = useAuth();

  return (
    <div className={className}>
      <Link href={href as any}>
        <motion.div whileHover={{ scale: 1.1 }} whileTap={{ scale: 0.98 }}>
          <div className="flex h-10 w-10 items-center justify-center rounded-full bg-muted font-bold md:h-14 md:w-14">
            {userProfile && getInitials(userProfile.name)}
          </div>
        </motion.div>
      </Link>
    </div>
  );
};
